import {createBreakpoints} from "../../helpers";
export default (breakpoints = {}) => createBreakpoints(breakpoints);